import React, { Component } from 'react';
import CreditRatingSelect from '../../components/SelectBox/CreditRatingSelect';
import BBImageLink from '../../components/ImageLink/BBImageLink';

// Stylesheets
import './styles';

class CreditRating extends Component {
  render() {
    return (
      <div className="credit-rating-component">
        <div className="columns credit-column">
          <CreditRatingSelect />
        </div>
        <div className="columns link-column">
          <BBImageLink />
        </div>
      </div>
    );
  }
}

export default CreditRating;



/** WEBPACK FOOTER **
 ** ./src/components/CreditRating/index.js
 **/